"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var prefetchViewport_exports = {};
__export(prefetchViewport_exports, {
  createPrefetchViewport: () => createPrefetchViewport,
  observePrefetchViewport: () => observePrefetchViewport,
  startPrefetchViewport: () => startPrefetchViewport
});
module.exports = __toCommonJS(prefetchViewport_exports);
function createPrefetchViewport() {
  var done = /* @__PURE__ */ new Set();
  var nodes = /* @__PURE__ */ new Map();
  var io = null;
  var onPrefetch = null;
  function getObserver() {
    if (io) return io;
    io = new IntersectionObserver(function(entries) {
      var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = void 0;
      try {
        for (var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var entry = _step.value;
          if (!entry.isIntersecting) continue;
          var href = nodes.get(entry.target);
          if (href && !done.has(href)) {
            done.add(href);
            onPrefetch === null || onPrefetch === void 0 ? void 0 : onPrefetch(href);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }
    }, {
      threshold: 0.5
    });
    return io;
  }
  function start(prefetch) {
    onPrefetch = prefetch;
  }
  function observe(el, href) {
    nodes.set(el, href);
    getObserver().observe(el);
    return function() {
      nodes.delete(el);
      io === null || io === void 0 ? void 0 : io.unobserve(el);
      done.delete(href);
    };
  }
  return {
    start,
    observe,
    done,
    nodes
  };
}
var instance = null;
function startPrefetchViewport(prefetch) {
  if (!instance) instance = createPrefetchViewport();
  instance.start(prefetch);
}
function observePrefetchViewport(el, href) {
  if (!instance) instance = createPrefetchViewport();
  return instance.observe(el, href);
}
//# sourceMappingURL=prefetchViewport.js.map
